import React, { useCallback, useEffect, useRef, memo } from 'react';
import { IonCol, IonRow } from '@ionic/react';

import { useAppDispatch } from '../../../../../store/Hooks';
import { getListByName } from '../../../../../store/catalogs/ValueList';

import BaseSelectMultiCheckbox from '../../../../common/BaseSelectMultiCheckbox';
import Textarea from '../../../../common/Textarea';

interface IssueRequestTypeProps {
  setValueIssue: (property: string, value: any, issueId?: any) => void;
  issue: any;
  isReadOnlyMode?: boolean;
}

const IssueRequestType: React.FC<IssueRequestTypeProps> = memo(
  ({ setValueIssue, issue, isReadOnlyMode }) => {
    const chairRef = useRef<any>();
    const dispatch = useAppDispatch();

    const issueRequestTypes = dispatch(getListByName('Issue_Request_Types'));

    const issueRef = useRef(issue);
    issueRef.current = issue;

    const issueRequestTypesRef = useRef(issueRequestTypes);
    issueRequestTypesRef.current = issueRequestTypes;

    const handleRequestTypeClick = useCallback(
      (name: string, checked: boolean) => {
        const currentIssue = issueRef.current;
        const requestTypesList = issueRequestTypesRef.current;

        if (!currentIssue) return;

        let requestTypes: string[] = currentIssue.requestTypes
          ? currentIssue.requestTypes.filter((r: string) => r.trim() !== '')
          : [];

        if (checked) requestTypes = [...requestTypes, name.trim()];

        if (requestTypes.length === 0) {
          requestTypes.push('');
        } else {
          requestTypes = requestTypes.filter((r: string) =>
            requestTypesList?.includes(r)
          );
        }

        setValueIssue('requestTypes', requestTypes);
      },
      [setValueIssue]
    );

    const handleRequestTypeIsChecked = useCallback(
      (value: string) => {
        return (
          issueRef.current?.requestTypes
            ?.map((v: string) => v.trimRight())
            ?.includes(value.trim()) ?? false
        );
      },
      [issue?.requestTypes]
    );

    useEffect(() => {
      if (chairRef) chairRef.current?.focus();
    }, []);

    return (
      <>
        <IonRow>
          <IonRow className='top-2'>
            <IonCol className='bold to-left top-1'>Request Type</IonCol>
          </IonRow>
        </IonRow>
        {issueRequestTypes && issueRequestTypes.length > 0 && (
          <IonRow className='top-2'>
            <BaseSelectMultiCheckbox
              isReadOnlyMode={isReadOnlyMode}
              source={issueRequestTypes}
              selectedItems={issue?.requestTypes ?? []}
              onClickButton={handleRequestTypeClick}
              isChecked={handleRequestTypeIsChecked}
            />
          </IonRow>
        )}
        <IonRow className='top-2'>
          <IonCol>
            <Textarea
              contentEditable={!isReadOnlyMode}
              label={'Description'}
              value={issue && issue.description ? issue.description : ''}
              onBlur={(e: any) => {
                let isDifferent = issue.description != e.target.innerText;
                if (isDifferent)
                  setValueIssue('description', e.target.innerText);
              }}
            />
          </IonCol>
        </IonRow>
      </>
    );
  }
);

export default IssueRequestType;
